<template>
  <div>
      <b-form>
        <FormulateInput
            v-model="formValues"
            class="mt-3"
            label="Contact Information"
            name="contactInfo"
            type="group"
            :repeatable="true"
            add-label="+ Additional Contact Information"
            validation="min:1,length"
        >
        <b-row>
            <b-col md="6">
                <b-form-group id="input-group-1">
                    <FormulateInput 
                        name="name" 
                        type="text"
                        placeholder="Contact's Name"
                        :validation="[
                            ['^required'],
                            ['specialChar']
                        ]"
                        :validation-rules="{
                            specialChar
                        }"
                        :validation-messages="{
                            specialChar:`Please type in a valid name.`,
                        }"
                    />
                </b-form-group>
            </b-col>

            <b-col md="6">
                <FormulateInput 
                name="relationship" 
                type="text"
                placeholder="Relationship to student" 
                />
            </b-col>
            
            <b-col md="6">
                <FormulateInput 
                name="email" 
                type="email"
                placeholder="Contact's email address" 
                validation="^required|email"
                />
            </b-col>
                       
            <b-col md="6">
                <FormulateInput 
                    name="phone" 
                    type="tel"
                    v-mask="'(###) ###-####'"
                    placeholder="Contact's Phone Number" 
                    validation="^required">
                </FormulateInput>

            </b-col>
          </b-row>
        </FormulateInput>
      </b-form>
  </div>
</template>
<script>
import { mask } from 'vue-the-mask'

    export default {
        name: "ContactInfo",
        directives: {mask},
        data() {
            return {
                formValues: {},
            };
        },
        props: {
          defaultValue: [],
        },
        methods: {
            specialChar ({ value }) {
                var format = /[`!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/;
                return !format.test(value)

            },
            handle () {
                this.$emit('input', this.formValues)
                alert('contactInfo submitted.')
            },
            setDefaultContactInfo () {
              this.formValues =  this.defaultValue ? this.defaultValue : ''
            },
        },
        mounted() {
          this.setDefaultContactInfo ()
        },    
      }
</script>
